import { Component, ViewChild, OnInit } from '@angular/core';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Observable, BehaviorSubject, of } from 'rxjs';
import { map, tap, scan, mergeMap, throttleTime } from 'rxjs/operators';
import { Purchase } from 'src/app/models/purchase.model';
import { NbDialogService } from '@nebular/theme';
import { SharedService } from 'src/app/shared/services/shared.service';
import { User } from 'src/app/models/users.model';
import { ActivatedRoute } from '@angular/router';
import { InfiniteList } from 'src/app/models/infinite-list.model';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
const firestore = firebase.firestore;

@Component({
  selector: 'app-purchase-history',
  templateUrl: './purchase-history.component.html',
  styleUrls: ['./purchase-history.component.scss'],
})
export class PurchaseHistoryComponent implements OnInit {
  infiniteList: InfiniteList<Purchase> = {
    data: [],
    placeholders: [],
    loading: false,
    theEnd: false,
    pageSize: 25,
  };

  user: User;
  loading = true;

  constructor(
    private ss: SharedService,
    private activatedRoute: ActivatedRoute,
    private db: AngularFirestore,
    private dialogService: NbDialogService,
  ) {}

  async ngOnInit() {
    this.user = await this.ss.getUser();

    const purchaseUid = this.activatedRoute.snapshot.paramMap.get('purchaseUid');
    if (purchaseUid) {
      const purchase = (
        await firestore().collection(`purchases`).where('uid', '==', purchaseUid).where('userUid', '==', this.user.uid).get()
      ).docs[0].data() as Purchase;
      this.openModal(purchase);
    }
  }

  getBatch(startAfter: Date | firebase.firestore.Timestamp) {
    return this.db
      .collection<Purchase>('purchases', (ref) =>
        ref.where('userUid', '==', this.user.uid).orderBy('purchaseDate', 'desc').startAfter(startAfter).limit(this.infiniteList.pageSize),
      )
      .snapshotChanges();
  }

  loadNext(listData: InfiniteList<Purchase>) {
    if (listData.loading || listData.theEnd) {
      return;
    }

    listData.loading = true;
    listData.placeholders = new Array(1);

    this.getBatch(listData.data[listData.data.length - 1]?.purchaseDate ?? new Date('3000')).subscribe((next) => {
      if (next[0]?.payload.doc.metadata.fromCache) {
        return;
      }
      console.log('Load Next');
      this.loading = false;
      listData.placeholders = [];
      listData.loading = false;

      if (next.length < this.infiniteList.pageSize) {
        this.infiniteList.theEnd = true;
      }
      next.forEach((_data) => {
        const data = _data.payload.doc.data();
        const index = listData.data.findIndex((a) => a.uid === data.uid);
        if (index > -1) {
          listData.data[index] = data;
        } else {
          listData.data.push(data);
        }
      });
    });
  }

  openModal(purchase: Purchase) {
    // this.dialogService.open(PurchaseDetailsComponent, {
    //   context: {
    //     purchaseUid: purchase,
    //   },
    // });
  }
}
